import { AiTaskTypeT } from '@/api/aiApi/types';

export const TASK_LABEL: Record<AiTaskTypeT, string> = {
    RemoveBg: 'Убираем фон',
    ClothingAttributes: 'Распознаем категории',
    OutfitTryOn: 'Анализируем коллаж',
};
